import React, { useEffect, useState } from 'react';
import SSRProduct from '../ssr-product';
import { useSelector } from 'react-redux';
import { useToast } from '@/hooks/use-toast';

interface MealI {
  data: any;
  type: 'meal';
  selected: () => void;
  meal: any;
  activeIndexes: any;
}

const Meal: React.FC<MealI> = ({ meal, activeIndexes }) => {
  const [Count, setCount] = useState<number>(0);
  const meals = meal;
  const passengerCount = useSelector(
    (state: any) =>
      state.flightSearch.passengers.adult + state.flightSearch.passengers.child,
  );
  const { toast } = useToast();

  const ssrData = useSelector((state: any) => state.flightSearch.selectedSSR);

  useEffect(() => {
    // handleSelected(0);
  }, [ssrData]);

  // setCount(passengerCount);

  const handleSelected = (count: number) => {
    setCount(count);
  };

  const calculateTotalCounts = (selectedSSR: any) => {
    let totalMeals = 0;

    if (selectedSSR?.length > 0) {
      selectedSSR.forEach((pax: any) => {
        pax.forEach((flight: any) => {
          flight.forEach((segment: any) => {
            if (segment.meal) {
              totalMeals += segment.meal.count || 0;
            }
          });
        });
      });

      return { totalMeals };
    }
  };

  return (
    <div>
      {/* Meal count */}
      <p className="mb-4 text-sm text-gray-500">
        {calculateTotalCounts(ssrData)?.totalMeals} of {passengerCount} meal(s)
        selected
      </p>
      <div className="flex h-96 flex-col gap-5 overflow-y-auto">
        {meals &&
          meals?.length > 0 &&
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          meals.map((meal: any, index: number) => {
            if (!meal.desc) return null;
            return (
              <SSRProduct
                key={meal?.id || meal?.desc || `meal-${index}`}
                data={meal}
                type="meal"
                activeIndexes={activeIndexes}
                selected={() => {
                  handleSelected(Count);
                  return Count;
                }}
              />
            );
          })}
        {meals && meals?.length == 0 && (
          <div className="flex h-full items-center justify-center">
            <p className="text-sm text-gray-500">No meal data found</p>
          </div>
        )}
      </div>
    </div>
  );
};
export default Meal;
